export const TypingTestIds = {
  containerTypingmessage: 'container_typingmessage',
  contentTypingmessage: 'content_typingmessage',
  textTypingmessage: 'text_typingmessage',
  textSingleuserTyping: 'text_singleuser_typing',
  textMultipleusersTyping: 'text_multipleusers_typing'
} as const;
